<template>
  <div
    class="my-header-parent"
    :class="isTop ? 'my-header-parent-top' : ''"
  >
    <div class="my-header">
      <img
        class="logo"
        :src="isTop ? '/images/logo（白色）.png' : '/images/logo.png'"
        alt=""
        @click="$router.push('/')"
      >
      <!-- <div class="liquor" @click="$router.push('/liquor/index')">酒专栏</div> -->
      <div class="menu">
        <el-menu
          v-if="showMenu"
          mode="horizontal"
          :default-active="active"
          router
        >
          <el-menu-item index="/">
            首页
          </el-menu-item>
          <div @click="changeProduct(value)">
            <el-select
              v-model="value"
              class="productCheck"
              placeholder="商品百科"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                @click.native="changeProduct($event,value)"
              />
            </el-select>
          </div>
          <!--<el-menu-item index="/product">商品百科</el-menu-item>-->
          <el-menu-item index="/service/yxzt">
            商品营销
          </el-menu-item>
          <el-menu-item
            index="/product/place"
            class="cd"
          >
            商品产地
          </el-menu-item>
          <!-- <el-menu-item index="/service/yxzt">
          <el-dropdown placement="bottom-start" @command="onCommand">
            <span>商品营销</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="/service/yxzt">营销主题</el-dropdown-item>
              <el-dropdown-item command="/service/fwxs">24节气</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          </el-menu-item>-->
          <!--<el-menu-item index="/ovop">一村一品</el-menu-item>-->
        </el-menu>
      </div>
      <div>
        <ProductSearch class="search" />
        <div class="vertical" />
        <el-dropdown class="bus">
          <el-button>
            系统换乘
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>品类管理</el-dropdown-item>
            <el-dropdown-item>食安云网</el-dropdown-item>
            <el-dropdown-item>采购中台</el-dropdown-item>
            <el-dropdown-item>供零在线</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <MyHeader class="my" />
    </div>
    <div
      v-if="showSub"
      class="my-header-menu"
    >
      <el-row
        type="flex"
        justify="space-between"
      >
        <el-col :span="8">
          <div class="left">
            <slot name="left" />
          </div>
        </el-col>
        <el-col :span="8">
          <div
            v-if="subMenu.length > 0"
            class="menu"
          >
            <div
              v-for="(item, index) in subMenu"
              :key="index"
              :class="item.active ? 'item active' : 'item'"
              :style="(index > 0 && index < subMenu.length - 1) ? 'border-left: none; border-right: none' : ''"
              @click="!item.disabled && $router.push(item.path)"
            >
              {{ item.name }}
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="right">
            <slot name="right" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ProductSearch from '@/components/ProductSearch.vue'
import MyHeader from '@/components/MyHeader'

export default {
  name: 'Header',
  components: {
    ProductSearch,
    MyHeader
  },
  inject: ['reload'],
  props: {
    showMenu: {
      type: Boolean,
      default: true
    },
    active: {
      type: String,
      default: ''
    },
    showSub: {
      type: Boolean,
      default: false
    },
    subMenu: {
      type: Array,
      default() {
        return []
      },
      required: false
    },
    enableTop: {
      type: Boolean,
      default: false
    },
    productValue: {
      type: String,
      default: ''
    }
  }, // 注入reload方法
  data() {
    return {
      scrollTop: 0,
      options: [{
        value: '1',
        label: '全国直采'
      }, {
        value: '2',
        label: '区域直采'
      }, {
        value: '3',
        label: '自有品牌'
      }, {
        value: '4',
        label: '生鲜进口商品'
      }, {
        value: '5',
        label: '一村一品'
      }, {
        value: '6',
        label: '1233商品'
      }],
      value: this.productValue
    }
  },
  computed: {
    isTop() {
      return this.enableTop && this.scrollTop < 300
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    handleScroll(e) {
      this.scrollTop = e.target.documentElement && e.target.documentElement.scrollTop
    },
    onCommand(e) {
      this.$router.push(e)
    },
    changeProduct(e, value) {
      this.reload()
      let fullPath = this.$route.fullPath
      this.util.setVariantSession('tagId', value)
      this.util.setVariantSession('tag', this.options.filter((item) => item.value === value)[0].label)
      console.log(value)
      if (value === '5') { // 一村一品 跳转到新页面
        fullPath !== '/ovop' && this.$router.push('/ovop') // 路由不变化不进行跳转
      } else if (value === '3') { // 自有品牌 跳转到新页面
        fullPath !== '/ownBrandProduct' && this.$router.push('/ownBrandProduct') // 路由不变化不进行跳转
      } else {
        fullPath !== `/product?id=${value}` && this.$router.push(`/product?id=${value}`)
      }
    }
  }
}
</script>

<style lang="scss">
.my-header {
  .el-menu.el-menu--horizontal {
    border-bottom: 0;
    margin: 20px 0;
    .el-menu-item {
      height: 30px;
      line-height: 30px;
    }
    .cd{
      margin-left: 10px;
    }
    .el-menu-item.is-active {
      color: #333333;
      font-weight: bold;
    }
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    // border-bottom: 1px solid #333;
    border: 0;
  }
  .el-menu--horizontal > .el-menu-item.is-active::after {
    content: "";
    height: 1px;
    background: rgba(51, 51, 51, 1);
    width: 75%;
    position: absolute;
    top: 30px;
    left: 10px;
  }
  .el-menu-item {
    font-size: 14px;
    padding: 0 10px;
    color: #848791;
    height: 30px;
    line-height: 30px;
  }

  .el-menu-item * {
    vertical-align: top;
  }

  .el-button {
    padding: 8px;
    font-size: 12px;
    margin-top: 7px;
  }
}
</style>

<style lang="scss">
.my-header-parent {
  width: 100%;
  box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.06);
  background: white;
  min-width: 1040px;
}
.my-header {
  display: flex;
  justify-content: space-around;
  width: 100%;
  // margin: 0 auto;
  .logo {
    cursor: pointer;
    width: 233px;
    height: 36px;
    overflow: hidden;
  }

  img {
    height: 36px;
    margin: 17px 0;
  }

  .title {
    display: inline-block;
    height: 60px;
    line-height: 60px;
    font-size: 28px;
    color: #3a8a63;
    vertical-align: top;
    font-weight: bold;
    margin-right: 100px;
  }

  .search {
    display: inline-block;
    width: 180px;
    vertical-align: top;
    margin: 18px 0;
  }

  .vertical {
    display: inline-block;
    width: 1px;
    height: 14px;
    margin: 28px 0 28px 20px;
    background: rgba(0, 0, 0, 0.4);
    // opacity: 0.4;
  }

  .my {
    width: 150px;
    vertical-align: top;
    float: right;
  }

  .bus {
    display: inline-block;
    vertical-align: top;
    margin-top: 15px;
    // margin-left: 100px;

    .el-dropdown-selfdefine {
      // border: 1px solid #e4c896;
      border: none;
      background: rgba(0, 0, 0, 0);

      color: #333333;
    }
  }

  .menu {
    width: 340px;
    display: inline-block;
    vertical-align: top;
    .productCheck{
      max-width: 128px;
      float: left;
      height: 30px;
      /* line-height: 30px; */
      display: flex;
      align-items: center;
      input{
        border: none;
        color: #333333;
        font-weight: bold;
      }
      ::-webkit-input-placeholder { /* WebKit browsers */
        color: #909399;
        font-weight: normal;
      }

      ::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: #909399;
        font-weight: normal;
      }

      :-ms-input-placeholder { /* Internet Explorer 10+ */
        color: #909399;
        font-weight: normal;
      }
    }
  }
}

.my-header-menu {
  width: 1100px;
  margin: 0 auto;
  height: 60px;
  text-align: center;
  .left {
    float: left;
    // position: absolute;
  }
  .menu {
    width: 330px;
    display: inline-block;
    margin: 15px auto;
    .item {
      width: 108px;
      height: 28px;
      display: inline-block;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(51, 51, 51, 1);
      text-align: center;
      line-height: 28px;
      font-size: 14px;
      cursor: pointer;
    }
    .active {
      color: white;
      background: rgba(51, 51, 51, 1);
    }
  }
  .right {
    float: right;
    // position: absolute;
    margin: 14px 0;
  }
}

.my-header-parent-top {
  opacity: 1;
  background: rgba(0, 0, 0, 0);
  z-index: 100;

  .bus {
    // background: rgba(255, 255, 255, 1);
    // opacity: 0.5;
    .el-dropdown-selfdefine {
      border: 1px none;
      // background: rgba(0, 0, 0, 0.5);

      color: white;
    }
  }

  .my {
    .el-dropdown-selfdefine {
      color: white;
    }
  }

  .vertical {
    background: rgba(255, 255, 255, 0.4);
  }

  .product-search .el-input {
    background: #656565;
    // opacity: 0.3;
  }

  .product-search .el-input .el-input__inner {
    background: rgba(0, 0, 0, 1);
    border: 1px solid rgba(0, 0, 0, 1);
  }

  .product-search .el-input .el-input__prefix {
    color: white;
  }

  .product-search .el-input .el-input__inner::placeholder {
    color: white;
    font-size: 12px;
  }
}
</style>
